import { FeedDisplayOptions } from '../../components/Feed';
import { StoryDisplay } from '../../enums';
import { FontComponents } from '../../utils/font';

export const FEED_DEFAULT_ANIMATIONS: FeedDisplayOptions['animations'] = [];
export const FEED_DEFAULT_COLUMNS: FeedDisplayOptions['columns'] = 'default';
export const FEED_DEFAULT_FONT: Record<StoryDisplay, FontComponents> = {
  [StoryDisplay.Round]: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '16px',
    'line-height': 'normal',
    'font-family': ["'Inter'", 'sans-serif'],
  },
  [StoryDisplay.Square]: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '20px',
    'line-height': 'normal',
    'font-family': ["'Inter'", 'sans-serif'],
  },
};
export const FEED_DEFAULT_GAP: FeedDisplayOptions['gap'] = '5px';
export const FEED_DEFAULT_WITH_RADIUS: FeedDisplayOptions['withRadius'] = false;

export const FEED_COLUMNS = {
  DESKTOP: 5,
  TABLET: 3,
  MOBILE: 2,
} as const;
export const FEED_STORY_RADIUS = '10px';
